import { useEffect, useState } from "react";

const useGetLoaclIp = () => {
  const [localIP, setLocalIP] = useState<string | null>(null);

  useEffect(() => {
    // 获取设备ip
    const RTCPeerConnection =
      window.RTCPeerConnection ||
      //@ts-ignore
      window.mozRTCPeerConnection ||
      //@ts-ignore
      window.webkitRTCPeerConnection;
    if (!RTCPeerConnection) {
      console.error("RTCPeerConnection is not supported in this browser");
      return;
    }

    const pc = new RTCPeerConnection({ iceServers: [] });
    const noop = () => {};

    pc.createDataChannel("");
    pc.createOffer().then((...args) => {
      pc?.setLocalDescription?.(...args);
    }, noop);

    pc.onicecandidate = (ice) => {
      if (!ice || !ice.candidate) return;
      const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
      const ipMatch = ice.candidate.candidate.match(ipRegex);
      if (ipMatch) {
        console.log("ipMatch===", ipMatch);
        setLocalIP(ipMatch[1]);
        pc.close();
      }
    };
  }, []);

  return { localIP };
};

export default useGetLoaclIp;
